import styled from "styled-components";
//let { innerHeight, innerWidth } = window

// const ksh42 = require("../../static/image/ksh42.png");

export const Container = styled.div`
    width:100%;
  .container2 {
    margin: 8px auto;
    width: 95%;
    height: 100%;
    .listItem{
      padding:4px 0;
    }
    .img{
      width:100%;
      border-radius: 8px;
      height: 100%;
    }
  }
`
